import { defineIdentity } from '../featureModule'

/**
 * Settings feature identity. The settings feature (a hub — migrates last)
 * is NOT yet migrated to a module — this identity exists so its
 * cross-feature contracts (below) have an owner. The worker keeps gating
 * the rest of the settings surface via the legacy map until the settings
 * migration lands.
 */
export const identity = defineIdentity({ name: 'settings', entitlements: ['settings'] })
